import React from 'react';
import { HashRouter } from 'react-router-dom';
import GeneralRouter from './GeneralRouter';

const AppRouter: React.FC = () => {
    return (
        <HashRouter>
            <GeneralRouter />
        </HashRouter>
    );
};

export default AppRouter;
